import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const passRoutes: RouteRecordRaw[] = [
  {
    path: '/passes',
    name: ROUTES.PASSES,
    component: () => import('@/modules/passes/views/PassesIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.MOBILE_PASS_VIEW }
  },
  {
    path: '/passes/:id',
    name: ROUTES.PASS_DETAILS,
    component: () => import('@/modules/passes/views/PassDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.PASS_DETAILS_VIEW }
  }
]
